import Home from "./components/Home";
import React from "react";
import SpeakerInvitationSentConfirmation from "./components/SpeakerInvitations/SpeakerInvitationSentConfirmation";
import SpeakerInvitationWithValidation from "./components/SpeakerInvitations/SpeakerInvitationValidation";
import CancelledSpeakerInvitation from "./components/SpeakerInvitations/CancelledSpeakerInvitation";
import SpeakerInvitationAlreadySubmitted from "./components/SpeakerInvitations/SpeakerInvitationAlreadySubmitted";
import ExpiredSpeakerInvitation from "./components/SpeakerInvitations/ExpiredSpeakerInvitation";

const AppRoutes = [
    {
        id: 0,
        index: true,
        element: <Home />
    },
    {
        id: 1,
        path: 'speaker/invitation/:invitationId',
        element: <SpeakerInvitationWithValidation />
    },
    {
        id: 2,
        path: 'speaker/invitation/sent',
        element: <SpeakerInvitationSentConfirmation />
    },
    {
        id: 3,
        path: 'speaker/invitation/cancelled',
        element: <CancelledSpeakerInvitation />
    },
    {
        id: 4,
        path: 'speaker/invitation/expired',
        element: <ExpiredSpeakerInvitation />
    },
    {
        id: 5,
        path: 'speaker/invitation/alreadySubmitted',
        element: <SpeakerInvitationAlreadySubmitted />
    }
];

export default AppRoutes;
